// src/store/actions/ticketsActions.js
import axios from "axios";

export const GET_TICKETS_REQUEST = "GET_TICKETS_REQUEST";
export const GET_TICKETS_SUCCESS = "GET_TICKETS_SUCCESS";
export const GET_TICKETS_FAIL = "GET_TICKETS_FAIL";

export const ADD_TICKET = "ADD_TICKET";
export const UPDATE_TICKET = "UPDATE_TICKET";
export const DELETE_TICKET = "DELETE_TICKET";

const API = process.env.REACT_APP_API_URL;

export const getTickets = (providerId) => async (dispatch) => {
  dispatch({ type: GET_TICKETS_REQUEST });
  try {
    const res = await axios.get(`${API}/tickets/get_tickets_by_provider/${providerId}`);
    dispatch({ type: GET_TICKETS_SUCCESS, payload: res.data.data || res.data });
  } catch (error) {
    dispatch({ type: GET_TICKETS_FAIL, payload: error.message || error });
  }
};

export const addTicket = (payload) => async (dispatch) => {
  const res = await axios.post(`${API}/tickets/add_ticket`, payload);
  dispatch({ type: ADD_TICKET, payload: res.data.data });
};

export const updateTicket = ({ id, payload }) => async (dispatch) => {
  const res = await axios.put(`${API}/tickets/update_ticket/${id}`, payload);
  dispatch({ type: UPDATE_TICKET, payload: res.data.data });
};

export const deleteTicket = ({ ticketId }) => async (dispatch) => {
  const res = await axios.delete(`${API}/tickets/delete_ticket/${ticketId}`);
  dispatch({ type: DELETE_TICKET, payload: res.data.data });
};
